import React from 'react'
import {
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from '@material-ui/core'
import { Stack, TextField } from '@mui/material'
import ReactTooltip from 'react-tooltip'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import NumberFormat from 'react-number-format'
import { useHistory } from 'react-router-dom'
import ExitIcon from '@material-ui/icons/ExitToApp'
import { useFormik } from 'formik'
import Moment from 'moment'
import { useFormMonitoringAndEvaluation } from '../../../../context/MonitoringAndEvaluationContext'
import { useMonitoreo } from '../../../../context/MonitoreoContext'
import { useAuthentication } from '../../../../context/authenticationContext'
import ROUTES from '../../../../routers/routes'

export const MonitoreoSeccion1 = (props) => {
  const [, dispatch] = useMonitoreo()
  const { userIDB2C } = useAuthentication()
  const { goToStep } = props
  const history = useHistory()
  const { monitoringAndEvaluationForm } = useFormMonitoringAndEvaluation()

  const valueDate = {
    someDate: new Date().toISOString().substring(0, 10),
  }

  const formik = useFormik({
    validateOnChange: false,
    initialValues: {
      MiPymeName: monitoringAndEvaluationForm.MiPymeName || '',
      SubprojectName: monitoringAndEvaluationForm.SubprojectName || '',
      ImplementationDateStart:
        Moment(monitoringAndEvaluationForm.ImplementationDateStart)
          .format('YYYY-MM-DD')
          .toString() || '',
      ImplementationDateEnd:
        Moment(monitoringAndEvaluationForm.ImplementationDateEnd)
          .format('YYYY-MM-DD')
          .toString() || '',
      IdReportAnswer: monitoringAndEvaluationForm.IdReportAnswer || 0,
      IdQuestionnaireAnswer:
        monitoringAndEvaluationForm.IdQuestionnaireAnswer || '',
      IdFormAction: 65,
      IdUserAzureB2C: userIDB2C,
      Draft: true,
      IdReportType: 7,
      Presentation_Date: valueDate.someDate,
      IdMiPyme: monitoringAndEvaluationForm.IdMiPyme || '',
      CurrentDateimplementation:
        Moment(monitoringAndEvaluationForm.CurrentDateimplementation)
          .format('YYYY-MM-DD')
          .toString() || '',
      ReportingPeriod:
        Moment(monitoringAndEvaluationForm.ReportingPeriod)
          .format('YYYY-MM-DD')
          .toString() || '',
      RequiredAmountDollarsCurrency:
        monitoringAndEvaluationForm.RequiredAmountDollarsCurrency || '',
      TotalSubProjectBudgetDollar:
        monitoringAndEvaluationForm.TotalSubProjectBudgetDollar || '',
      TypeReporte: monitoringAndEvaluationForm.TypeReporte || '',
    },
  })

  // const saveValuesToContext = (values) => {
  //   console.log('los values', values)
  //   setMonitoringAndEvaluationForm((previous) => {
  //     const valuesSave = {
  //       IdQuestionnaireAnswer: values.IdQuestionnaireAnswer,
  //       IdFormAction: values.IdFormAction,
  //       IdReportType: values.IdReportType,
  //       Presentation_Date: values.Presentation_Date,
  //       IdReportAnswer: formik.values.IdReportAnswer,
  //       Indicator_Description: values.Indicator_Description,
  //       Draft: values.Draft,
  //       IdUserAzureB2C: values.IdUserAzureB2C,
  //       SubprojectName: values.SubprojectName,
  //       IdMiPyme: values.IdMiPyme,
  //     }
  //     return {
  //       ...previous,
  //       ...valuesSave,
  //     }
  //   })
  // }

  const next = () => {
    dispatch({ type: 'SET_STATE', payload: 2 })
    goToStep(2)
  }

  return (
    <>
      <Grid
        container
        md={12}
        sm={12}
        spacing={1}
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <Grid item>
          <div
            data-tip
            data-for="exitPop"
            onClick={() => {
              history.push(ROUTES.IFIFORMSSENT.pathname)
            }}
            style={{
              backgroundColor: 'red',
              color: '#fff',
              width: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '4px',
              padding: '5px',
              cursor: 'pointer',
            }}
          >
            <ExitIcon style={{ transform: 'scaleX(-1)' }} />
            <ReactTooltip id="exitPop" effect="solid" backgroundColor="red">
              <span>Regresar</span>
            </ReactTooltip>
          </div>
        </Grid>
      </Grid>

      <form id="transfers-form">
        <div style={{ marginBottom: '48px' }}>
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
            spacing={1}
            style={{ marginTop: '18px', marginBottom: '16px' }}
          >
            <Grid item md={12} sm={12} xs={12}>
              <div
                style={{
                  fontSize: '24px',
                  fontWeight: 'bold',
                  marginBottom: '8px',
                }}
              >
                <label className="formTitle">Información General</label>
              </div>
              <label className="formDescription">
                Informe de seguimiento de medio término al progreso de
                subproyetos
              </label>
            </Grid>
          </Grid>
        </div>
        <Grid container spacing={1}>
          <Grid container spacing={1} className="input__container">
            <Grid item xs={6} sm={6} md={6}>
              <label className="responsiveLabel">
                1.1. Nombre de la MIPYME
              </label>
            </Grid>

            <Grid item xs={6} sm={6} md={6}>
              <label className="responsiveLabel">
                1.2 Título del subproyecto financiado
              </label>
            </Grid>

            <Grid item xs={6} sm={6} md={6}>
              <FormControl fullWidth>
                <TextField
                  id="MiPymeCountry"
                  name="MiPymeCountry"
                  type="text"
                  variant="outlined"
                  sx={{ width: '100%' }}
                  value={formik.values.MiPymeName}
                  disabled
                />
              </FormControl>
            </Grid>

            <Grid item xs={6} sm={6} md={6}>
              <FormControl fullWidth>
                <TextField
                  id="MiPymeCountry"
                  name="MiPymeCountry"
                  type="text"
                  variant="outlined"
                  sx={{ width: '100%' }}
                  value={formik.values.SubprojectName}
                  disabled
                />
              </FormControl>
            </Grid>
          </Grid>
          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                1.3. Período estimado de implementación de la inversión
              </label>
            </Grid>

            <Grid item xs={6} sm={6} md={6}>
              <FormControl style={{ width: '100%' }}>
                <Stack noValidate spacing={3}>
                  <TextField
                    id="ImplementationDateStart"
                    label="Desde"
                    type="date"
                    name="ImplementationDateStart"
                    variant="outlined"
                    // defaultValue={formik.ImplementationDateStart}
                    sx={{ width: '100%' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    value={formik.values.ImplementationDateStart}
                  />
                </Stack>
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <FormControl style={{ width: '100%' }}>
                <Stack noValidate spacing={3}>
                  <TextField
                    id="ImplementationDateEnd"
                    name="ImplementationDateEnd"
                    label="Hasta"
                    type="date"
                    variant="outlined"
                    value={formik.values.ImplementationDateEnd}
                    sx={{ width: '100%' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                  />
                </Stack>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={6} sm={6} md={6}>
              <label className="responsiveLabel">
                1.4. Fecha en curso de la implementación
              </label>
              <a
                data-tip="- Fecha media del período de implementación <br/>  de la inversión"
                data-for="infoPymesPop"
                style={{ cursor: 'pointer' }}
              >
                <HelpOutlineIcon fontSize="small" />
                <ReactTooltip
                  id="infoPymesPop"
                  effect="solid"
                  multiline={true}
                  type="dark"
                />
              </a>
            </Grid>

            <Grid item xs={6} sm={6} md={6}>
              <label className="responsiveLabel">
                1.5. Fecha de presentación del informe
              </label>
            </Grid>

            <Grid item xs={6} sm={6} md={6}>
              <FormControl style={{ width: '100%' }}>
                <Stack noValidate spacing={3}>
                  <TextField
                    id="ImplementationDateStart"
                    label="Desde"
                    type="date"
                    name="ImplementationDateStart"
                    variant="outlined"
                    disabled
                    value={formik.values.CurrentDateimplementation}
                    sx={{ width: '100%' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Stack>
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <FormControl style={{ width: '100%' }}>
                <Stack noValidate spacing={3}>
                  <TextField
                    id="ImplementationDateEnd"
                    name="ImplementationDateEnd"
                    label="Hasta"
                    type="date"
                    variant="outlined"
                    sx={{ width: '100%' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled
                    value={formik.values.Presentation_Date}
                  />
                </Stack>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">
                1.6. Período del reporte
              </label>
            </Grid>

            <Grid item xs={6} sm={6} md={6}>
              <FormControl style={{ width: '100%' }}>
                <Stack noValidate spacing={3}>
                  <TextField
                    id="ImplementationDateStart"
                    label="Inicio proyecto"
                    type="date"
                    name="ImplementationDateStart"
                    variant="outlined"
                    sx={{ width: '100%' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={formik.values.ReportingPeriod}
                    disabled
                  />
                </Stack>
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <FormControl style={{ width: '100%' }}>
                <Stack noValidate spacing={3}>
                  <TextField
                    id="ImplementationDateEnd"
                    name="ImplementationDateEnd"
                    label="Fecha presentación"
                    type="date"
                    variant="outlined"
                    value={formik.values.Presentation_Date}
                    disabled
                    sx={{ width: '100%' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Stack>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={6} sm={6} md={6}>
              <label className="responsiveLabel">
                1.7. Presupuesto total del subproyecto
              </label>
            </Grid>

            <Grid item xs={6} sm={6} md={6}>
              <label className="responsiveLabel">
                1.8. Monto total del préstamo otorgado
              </label>
            </Grid>

            <Grid item xs={6} sm={6} md={6}>
              <FormControl style={{ width: '100%' }}>
                <NumberFormat
                  id="RequiredAmount"
                  name="RequiredAmount"
                  customInput={TextField}
                  thousandSeparator={true}
                  value={formik.values.RequiredAmountDollarsCurrency}
                  autoComplete="off"
                  disabled
                  prefix="$"
                  allowNegative={false}
                  variant="outlined"
                  isNumericString={true}
                  inputProps={{ maxLength: 13 }}
                  fixedDecimalScale
                  decimalScale={2}
                  className="multilineTextField"
                />
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={6} md={6}>
              <FormControl style={{ width: '100%' }}>
                <NumberFormat
                  id="RequiredAmount"
                  name="RequiredAmount"
                  customInput={TextField}
                  thousandSeparator={true}
                  value={formik.values.TotalSubProjectBudgetDollar}
                  autoComplete="off"
                  disabled
                  prefix="$"
                  allowNegative={false}
                  variant="outlined"
                  isNumericString={true}
                  inputProps={{ maxLength: 13 }}
                  fixedDecimalScale
                  decimalScale={2}
                  className="multilineTextField"
                />
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={12} md={12}>
              <label className="responsiveLabel">1.9. Tipo de informe</label>
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <RadioGroup
                  id="TypeBeneficiary"
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="radio-buttons-group"
                  row
                  value={formik.values.TypeReporte}
                >
                  <FormControlLabel
                    value="Informe Medio Termino"
                    control={<Radio />}
                    label="Medio término"
                    disabled
                  />
                  <FormControlLabel
                    value="Informe Final Termino"
                    control={<Radio />}
                    label="Final de término"
                    disabled
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={1} className="general_button">
            <Grid item xs={12} sm={12} md={12} style={{ textAlign: 'right' }}>
              <Button
                type="button"
                onClick={() => next()}
                className="button__wizard button__next"
              >
                Siguiente
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  )
}
